import router from '../router/index';

import { createStore } from "vuex";
import api from "../api/backend-api";

export default createStore({
  state: {
    userId: '',
    loginSuccess: false,
    userToken: '',
    displayName: null,
    authority: [],
  },
  mutations: {
    load_state(state, storedState) {
      if (!storedState) {
        return;
      }
      Object.assign(state, JSON.parse(storedState));
      api.setAuthToken(state.userToken);
    },
    login_success(state, payload) {
      state.loginSuccess = true;
      state.userId = payload.userId;
      state.userToken = payload.userToken;
      state.displayName = payload.displayName;
      state.authority = payload.authority;
      localStorage.setItem('storestate', JSON.stringify(state));
      api.setAuthToken(state.userToken);
    },
    login_error(state) {
      state.loginSuccess = false;
      state.userId = '';
      state.userToken = '';
      state.displayName = null;
      state.authority = [];
      localStorage.setItem('storestate', JSON.stringify(state));
      api.setAuthToken(state.userToken);
    },
    login_expire(state) {
      state.loginSuccess = false;
      state.userId = '';
      state.userToken = '';
      state.authority = [];
      localStorage.setItem('storestate', JSON.stringify(state));
      api.setAuthToken(state.userToken);
      router.push('/login')
    },
  },
  actions: {
    init({ commit }) {
      // console.log('loading state from storage');
      const storedState = localStorage.getItem('storestate');
      commit('load_state', storedState)
    },
    logout({ commit }) {
      api.doLogout()
      const storedState = localStorage.getItem('storestate');
      commit('login_expire', storedState)
    },
    login({ commit }, { user, password }) {
      return new Promise((resolve, reject) => {
        // console.log("Logging in..");
        api
          .doLogin(user, password)
          .then((response) => {
            // console.log("Response status: " + response.status);
            if (response.status == 200) {
              // place the loginSuccess state into our vuex store
              commit("login_success", {
                userId: response.data.UserId,
                userToken: response.data.Token,
                displayName: response.data.DisplayName,
                authority: response.data.Authority,
              });
            } else {
              commit("login_error");
            }
            resolve(response);
          })
          .catch(() => {
            // console.log("Error: " + error);
            // place the loginError state into our vuex store
            commit("login_error");
            reject("Login failed!");
          });
      });
    },
    checkAuthToken({ commit }) {
      return new Promise((resolve, reject) => {
        // console.log("Checking that authorisation is still valid");
        api
          .checkAuthToken()
          .then((response) => {
            resolve(response);
          })
          .catch(() => {
            // console.log("Session is gone: " + error);
            // place the loginError state into our vuex store
            commit("login_expire");
            reject("Session expired!");
          });
      });
    },
    maintainAuthToken({ dispatch, commit }) {
      return new Promise((reject) => {
        // console.log("Updating token from datastore");
        dispatch("checkAuthToken")
        .catch(() => {
          // console.log("Session is gone: " + error);
          commit("login_expire");
          reject("Session expired!");
        });
      });
    },
  },
  getters: {
    isLoggedIn: (state) => state.loginSuccess,
    getUserId: (state) => state.userId,
    getUserToken: (state) => state.userToken,
    getUserName: (state) => state.displayName,
    getUserAuthority: (state) => state.authority,
  },
});
